import { render, staticRenderFns } from "./IconGjh.vue?vue&type=template&id=728e7132"
import script from "./IconGjh.vue?vue&type=script&lang=js"
export * from "./IconGjh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports